import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { StockService } from 'src/app/services/datos/stock.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';


@Component({
  selector: 'app-fragmentacion-stock',
  templateUrl: './fragmentacion-stock.component.html',
  styleUrls: ['./fragmentacion-stock.component.scss']
})
export class FragmentacionStockComponent implements OnInit {

  // Emitir cuando haya datos
  @Output() tieneContenido = new EventEmitter<boolean>();

  public loading: boolean = false;
  fragmentacionData: any[] = [];

  constructor(
    private stockSrv: StockService,
    private notificSrv: NotificacionesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getResumenCompactacion();
  }

  // Datos resumidos por cliente
  getResumenCompactacion() {
    const opciones = {
      id_cliente: null,
      id_almacen: null
    }
    this.loading = true;
    this.stockSrv.getResumenCompactacion(opciones).subscribe({
      next: (resp: any) => {
        this.loading = false;

        console.log('__getResumenCompactacion() resp:', resp);

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return;
        }
        this.fragmentacionData = resp.data;

        // Si hay datos, emitir tieneContenido
        if (this.fragmentacionData && this.fragmentacionData.length > 0) {
          this.tieneContenido.emit(true);
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error al cargar Resumen Compactacion:', err);
      }
    });
  }

  detalleCliente(cliente: any) {
    this.router.navigate([
      '/panel/compactacion_analisis',
      cliente.id_cliente
    ]);
  }




  // Datos resumidos por cliente FAKE
  getResumenCompactacionFake() {
    this.loading = true;
    this.fragmentacionData = [
      {
        "id_almacen": 2,
        "id_cliente": 70,
        "severidad": {
          "baja": 2,
          "media": 1,
          "alta": 0
        },
        "cliente_nombre": "Festool"
      },
      {
        "id_almacen": 2,
        "id_cliente": 72,
        "severidad": {
          "baja": 2,
          "media": 0,
          "alta": 0
        },
        "cliente_nombre": "Clara_Cervera_Beauty"
      },
      {
        "id_almacen": 2,
        "id_cliente": 76,
        "severidad": {
          "baja": 8,
          "media": 4,
          "alta": 0
        },
        "cliente_nombre": "MELICONI ESPAÑA, S.L."
      },
      {
        "id_almacen": 2,
        "id_cliente": 79,
        "severidad": {
          "baja": 1,
          "media": 0,
          "alta": 0
        },
        "cliente_nombre": "Exposicionate"
      },
      {
        "id_almacen": 2,
        "id_cliente": 80,
        "severidad": {
          "baja": 1,
          "media": 0,
          "alta": 0
        },
        "cliente_nombre": "CATERING DE L' ANOIA"
      },
      {
        "id_almacen": 2,
        "id_cliente": 82,
        "severidad": {
          "baja": 0,
          "media": 1,
          "alta": 0
        },
        "cliente_nombre": "MONCOLOR BARCELONA, SL.                                 "
      }
    ]
    this.loading = false;
  }

}
